import React, { useEffect } from 'react';
import SearchHeader from '../../Common/SearchHeader';
import EventsListing from '../../Common/EventsListing';
import FindYourTribe from '../../Common/FindYourTribe';
import { ReactComponent as Entertainment } from '../../../Assets/bookmark.svg';
import { ReactComponent as Calendar } from '../../../Assets/calendar.svg';
import { ReactComponent as LocationIcon } from '../../../Assets/location-dark.svg';
import { ReactComponent as PriceTag } from '../../../Assets/price-tag.svg';
import { ReactComponent as Facebook } from '../../../Assets/social-fb.svg';
import { ReactComponent as Linkedin } from '../../../Assets/social-linkedin.svg';
import { ReactComponent as X } from '../../../Assets/social-X.svg';
import { ReactComponent as Whtsp } from '../../../Assets/social-whtsp.svg';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { addItem } from '../../../Redux/slices/cartSlice';
import { getEventById } from '../../../Redux/slices/eventSlice';
import mightLike from '../../../Assets/mightLike.svg';
import {
  capitalize,
  dateFormatter,
  dynamicImageRender,
  findMinimumPrice,
} from '../../../utils/helpers';
import { Skeleton } from 'antd';
import { useMediaQuery } from 'react-responsive';

const EventDetail = () => {
  const { eventDetails } = useSelector((state) => state.event);
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 600 });

  const handleAddToCart = () => {
    dispatch(addItem(eventDetails)); // Dispatch action to add item to cart
    navigate(`/cart/${id}`);
  };
  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    dispatch(getEventById({ id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const otherEvents = {
    events: eventDetails?.otherEvents,
    title: 'YOU MIGHT ALSO LIKE',
    icon: mightLike,
  };

  return (
    <div className="event-detail">
      <SearchHeader styleClass="header" showSearchBar={true} />
      <div className="content-container">
        <div className="left-container">
          <div className="img-container">
            {eventDetails == null ? (
              <Skeleton.Image active={true} className="border-radius-14" />
            ) : (
              <img
                src={
                  eventDetails?.coverImg === ''
                    ? dynamicImageRender(state.index)
                    : eventDetails?.coverImg
                }
                className={`border-radius-14 ${isMobile ? 'mobile-img' : ''}`}
                alt="event"
              />
            )}
          </div>
          {isMobile && (
            <div className="mobile-event-detail">
              {eventDetails == null ? (
                <Skeleton active={true} paragraph={{ rows: 4 }} title={true} />
              ) : (
                <>
                  <h2>{eventDetails?.title}</h2>
                  <div className="icon-text">
                    <Entertainment />
                    {capitalize(eventDetails?.type)}
                  </div>
                  <div className="icon-text">
                    <Calendar />
                    {dateFormatter(
                      eventDetails?.startDate,
                      eventDetails?.endDate
                    )}
                  </div>
                  <div className="icon-text">
                    <LocationIcon />
                    {eventDetails?.location.type === 'virtual'
                      ? 'Virtual Event'
                      : eventDetails?.location.city}
                  </div>
                </>
              )}
            </div>
          )}
          {eventDetails == null ? (
            <Skeleton active={true} className="border-radius-14" />
          ) : (
            <div className="about-section common-container border-radius-14">
              <h3>About</h3>
              <p
                dangerouslySetInnerHTML={{ __html: eventDetails.description }}
              />
            </div>
          )}
        </div>
        <div className="right-container">
          {!isMobile && (
            <div className="detail-container border-radius-14">
              {eventDetails == null ? (
                <Skeleton active={true} paragraph={{ rows: 4 }} title={true} />
              ) : (
                <>
                  <h2>{eventDetails?.title}</h2>
                  <p>
                    <Entertainment />
                    {capitalize(eventDetails?.type)}
                  </p>
                  <p>
                    <Calendar />
                    {dateFormatter(
                      eventDetails?.startDate,
                      eventDetails?.endDate
                    )}
                  </p>
                  <p>
                    <LocationIcon />
                    {eventDetails?.location.type === 'virtual'
                      ? 'Virtual Event'
                      : eventDetails?.location.city}
                  </p>
                  <p className="price">
                    {eventDetails?.startPrice
                      ? `Starts from ₹${eventDetails?.startPrice}`
                      : 'Free Entry'}
                  </p>
                </>
              )}
              {eventDetails == null ? (
                <Skeleton.Button
                  active={true}
                  block
                  style={{ marginTop: 12 }}
                  className="border-radius-8"
                />
              ) : (
                <div
                  className="button"
                  onClick={handleAddToCart}
                  onKeyDown={handleAddToCart}
                  style={{ borderRadius: 8 }}
                >
                  Book Now
                </div>
              )}
            </div>
          )}
          {eventDetails == null ? (
            <Skeleton
              active={true}
              paragraph={{ rows: 4 }}
              title={true}
              className="border-radius-14"
            />
          ) : (
            eventDetails?.location?.type !== 'virtual' && (
              <div className="location-container common-container border-radius-14">
                <h3>{eventDetails?.location?.city}</h3>
                <p className="address" style={{ fontSize: 20 }}>
                  {eventDetails?.location?.addressLine1}
                </p>
                <p className="address">
                  {eventDetails?.location?.addressLine2}
                  <br />
                  {eventDetails?.location?.city}
                  <br />
                  {eventDetails?.location.state}
                </p>
              </div>
            )
          )}
          {eventDetails != null && (
            <div className="social-links common-container border-radius-14">
              <h3>Share this event</h3>
              <div>
                <a
                  href={`http://www.facebook.com/sharer/sharer.php?u=${window.location}&t=${eventDetails?.title}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Facebook />
                </a>
                <a
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Linkedin />
                </a>
                {/* <Insta /> */}
                <a
                  href={`http://www.x.com/intent/tweet?url=${window.location}&text=${eventDetails?.title}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <X />
                </a>
                <a
                  href={`whatsapp://send?text=${window.location}`}
                  data-action="share/whatsapp/share"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Whtsp />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      <EventsListing
        eventList={otherEvents}
        hideViewAll={true}
        styleClass="listingWithCarousel"
      />
      <FindYourTribe />
      {eventDetails != null && isMobile && (
        <div className="sticky-footer">
          <div className="price-container">
            <PriceTag />
            <h3>
              ₹ {findMinimumPrice(eventDetails?.tickets) || 'Free'} Onwards
            </h3>
          </div>
          <div
            className="button"
            onClick={handleAddToCart}
            onKeyDown={handleAddToCart}
            style={{ borderRadius: 8 }}
          >
            Book Now
          </div>
        </div>
      )}
    </div>
  );
};

export default EventDetail;
